// extracted by mini-css-extract-plugin
export default {"toast":"ticket_integration_toast__Gt-2L","link":"ticket_integration_link__H7zqu"};